import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Pipe({
  name: 'estado', // Nombre del pipe que usarás en tu plantilla
})
export class EstadoPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}
  transform(value: string): string {
    if (value.toLowerCase() === 'active' || value.toLowerCase() === 'authorized' || value.toLowerCase() === 'approved') {
      return this.translate.instant('ACTIVE');
    } else {
      return this.translate.instant('INACTIVE');
    }
  }
}

@Pipe({
    name: 'monedaSimbolo'
  })
  export class MonedaSimboloPipe implements PipeTransform {
  
    transform(value: string): string {
      const simbolosMoneda: { [key: string]: string } = {
        'USD': 'USD', 
        'ARG': 'ARG', // Puedes agregar más monedas y símbolos aquí
        // ...
      };
      return simbolosMoneda[value.toUpperCase()] || value; // Devuelve el símbolo o el valor original si no se encuentra
    }
  }  


 